import React from 'react';
import { SeparatorWithTextLayoutProps } from '../types';

import styles from './SeparatorWithText.module.scss';

export default function SeparatorWithTextLayoutWeb(
  props: SeparatorWithTextLayoutProps,
) {
  const marginSize = props.marginSize || 'medium';

  const classNames = [
    styles.separatorWithText,
    `margin-${marginSize}`,
  ];

  return (
    <div className={classNames.join(' ')}>
      <div className={styles.line}></div>
      <span className={styles.text}>{props.text}</span>
      <div className={styles.line}></div>
    </div>
  );
}